
import { mapGetters } from "vuex";
import ProfilesListV2 from "@/components/v2/profiles-list-v2.vue";

export default {
  name: "Daily",
  components: { ProfilesListV2 },
  props: {
    girlsOfTheDay: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      gender: null,
    };
  },
  computed: {
    ...mapGetters({
      discreetMode: "getDiscreetStatus",
      decodedRouteParams: "profiles/getDecodedRouteParams",
      profileListViewMode: "catalog/getCatalogMode",
      profileMinCol: "catalog/getMinCol",
      catalogMode: "catalog/getCatalogMode",
    }),

    currentUrlGender() {
      const genderParam = this.decodedRouteParams?.find(
        (p) => p.type === "gender"
      );
      const urlToUiGender = {
        male: this.$t("males"),
        female: this.$t("girls"),
        transgender: this.$t("shemales"),
      };
      return urlToUiGender[genderParam?.name] || this.$t("profiles");
    },

    isFullMobile() {
      return this.profileMinCol == 2 && this.catalogMode == "grid";
    },
  },
};
